<template>
  <div class="p-auth">
    <aside class="p-auth__art">
      <div class="p-auth__brand">
        <img src="/favicon.png" alt="Pineapple" class="p-auth__logo" />
        <div class="p-auth__brand-text">
          <div class="p-auth__brand-name">Pineapple</div>
          <div class="p-auth__brand-sub">ACADEMY ADMIN</div>
        </div>
      </div>
      <div class="p-auth__pine">
        <PineCharacter :size="220" />
      </div>
      <p class="p-auth__tagline">
        Welcome back to<br />
        <strong>Pineapple Academy</strong>
      </p>
    </aside>

    <section class="p-auth__panel">
      <div class="p-auth__form">
        <header class="p-auth__head">
          <p class="p-auth__head-eyebrow">FOR {{ $CONF.APP_USERTYPE }}</p>
          <h1 class="p-auth__head-title">Sign In</h1>
          <p class="p-auth__head-sub">Enter your email and password to sign in</p>
        </header>

        <form class="p-auth__veeform" @submit.prevent>
          <div class="p-field">
            <label class="p-field__label" for="ill-email">
              <i class="material-icons-round p-field__label-icon">mail</i>
              이메일
            </label>
            <input id="ill-email" type="email" placeholder="name@example.com" class="p-input" />
          </div>

          <div class="p-field">
            <label class="p-field__label" for="ill-password">
              <i class="material-icons-round p-field__label-icon">lock</i>
              비밀번호
            </label>
            <input id="ill-password" type="password" placeholder="••••••••" class="p-input" />
          </div>

          <label class="p-auth__remember">
            <input type="checkbox" /> 로그인 상태 유지
          </label>

          <ABtn type="submit" kind="primary" block icon="login" class="p-auth__submit">Sign in</ABtn>

          <p class="p-auth__alt">
            계정이 없으신가요?
            <router-link :to="{ name: 'Signup Cover' }">회원가입</router-link>
          </p>
        </form>

        <p class="p-auth__footer">© {{ new Date().getFullYear() }} Pineapple Academy</p>
      </div>
    </section>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import ABtn from "@/components/Pineapple/ABtn.vue";
import PineCharacter from "@/components/Pineapple/PineCharacter.vue";

export default {
  name: "SigninIllustration",
  components: { ABtn, PineCharacter },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.p-auth {
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  background: $p-bg;
  font-family: $p-font-body;
}

.p-auth__art {
  background: linear-gradient(160deg, $p-point-soft 0%, $p-bg 60%, $p-panel-alt 100%);
  padding: 56px 64px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 32px;
  position: relative;
  overflow: hidden;

  &::before, &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
  }
  &::before {
    width: 320px; height: 320px;
    top: -120px; right: -120px;
    background: radial-gradient(circle, rgba(255, 201, 60, 0.25) 0%, transparent 70%);
  }
  &::after {
    width: 240px; height: 240px;
    bottom: -100px; left: -60px;
    background: radial-gradient(circle, rgba(30, 140, 102, 0.18) 0%, transparent 70%);
  }
}

.p-auth__brand {
  display: flex; align-items: center; gap: 12px;
  position: relative; z-index: 1;
}

.p-auth__logo { width: 40px; height: 40px; object-fit: contain; }

.p-auth__brand-name {
  font-size: 18px; font-weight: 800; color: $p-ink; line-height: 1.1;
}

.p-auth__brand-sub {
  font-size: 10px; font-weight: 700; letter-spacing: 0.14em;
  color: $p-point-deep; margin-top: 3px;
}

.p-auth__pine {
  display: flex; align-items: center; justify-content: center;
  flex: 1; position: relative; z-index: 1;
}

.p-auth__tagline {
  margin: 0; font-size: 16px; color: $p-ink2; line-height: 1.5;
  position: relative; z-index: 1;
  strong { color: $p-point-deep; font-weight: 800; }
}

.p-auth__panel {
  display: flex; align-items: center; justify-content: center;
  padding: 40px; background: $p-panel;
}

.p-auth__form { width: 100%; max-width: 380px; display: flex; flex-direction: column; gap: 24px; }
.p-auth__head { display: flex; flex-direction: column; gap: 4px; }
.p-auth__head-eyebrow { font-size: 11px; font-weight: 800; letter-spacing: 0.16em; color: $p-point-deep; margin: 0; }
.p-auth__head-title { margin: 0; font-size: 28px; font-weight: 800; color: $p-ink; }
.p-auth__head-sub { margin: 4px 0 0; font-size: 13px; color: $p-ink-mid; }
.p-auth__veeform { display: flex; flex-direction: column; gap: 4px; }

.p-auth__remember {
  display: inline-flex; align-items: center; gap: 6px;
  font-size: 12px; color: $p-ink-mid; cursor: pointer; margin-top: 4px;
  input { accent-color: $p-point-deep; }
}

.p-auth__submit { margin-top: 8px; height: 42px !important; }

.p-auth__alt {
  text-align: center; font-size: 13px; color: $p-ink-mid; margin: 8px 0 0;
  a { color: $p-point-deep; font-weight: 700; text-decoration: none;
    &:hover { text-decoration: underline; }
  }
}

.p-auth__footer { margin: 16px 0 0; text-align: center; font-size: 11px; color: $p-ink-soft; }

@media (max-width: 960px) {
  .p-auth { grid-template-columns: 1fr; }
  .p-auth__art { padding: 32px; min-height: 280px; }
  .p-auth__panel { padding: 32px 20px; }
}
</style>
